export default __webpack_public_path__ + "static/media/handprint-36-page.1e528785.png";